import React from 'react';
import { ClockIcon, SparklesIcon } from 'lucide-react';
import { Price } from './currency/Price';
export function TopBar() {
  return <header className="sticky top-0 z-50 border-b border-[#183d2b] bg-[#123323] px-4 py-2.5 text-[#fff9ed] shadow-sm" data-id="element-202" data-mp="231c3fysxbdws">
      <div className="mx-auto flex max-w-7xl items-center justify-center gap-2 text-center text-xs font-semibold tracking-[0.02em] sm:text-sm" data-id="element-203" data-mp="1y5wrjceh7s30">
        <SparklesIcon aria-hidden="true" className="h-4 w-4 shrink-0 text-[#f6c76d]" data-id="element-204" data-mp="2qsr8w0fzybc9" />
        <span data-id="element-205" data-mp="2lufztrxj04v3">Acceso inmediato + 5 bonos exclusivos gratis</span>
        <span className="hidden h-4 w-px bg-[#5d7d6b] sm:block" aria-hidden="true" data-id="element-206" data-mp="2h2eqadrqss8r" />
        <span className="hidden items-center gap-1 text-[#dce9df] sm:inline-flex" data-id="element-207" data-mp="2c43i07h3ipsn">
          <ClockIcon aria-hidden="true" className="h-3.5 w-3.5" data-id="element-208" data-mp="39ipg6ebz00eu" />
          Oferta especial: <Price amount={12.99} data-id="element-209" data-mp="39kshvvmhjhze" />
        </span>
      </div>
    </header>;
}